import queryStringParser from "query-string";
import { parseEnum } from "b2b-base/src/utils/enumCast";
import { DatelessSearchSource } from "redmond";
import dayjs from "dayjs";

export interface IPremierCollectionShopDetailsParsedQuery {
  lodgingId: string;
  unavailable?: boolean;
  source: DatelessSearchSource;
  vibe?: string;
  fromDate?: Date;
  untilDate?: Date;
}

export const parseShopDetailsQueryString = (
  url: string
): IPremierCollectionShopDetailsParsedQuery => {
  const parsedQueryStringPrimitive = queryStringParser.parse(url);

  const fromDateStr = parsedQueryStringPrimitive.fromDate as string | undefined;
  const untilDateStr =
    parsedQueryStringPrimitive.untilDate as string | undefined;

  const parsedQueryString: IPremierCollectionShopDetailsParsedQuery = {
    lodgingId: parsedQueryStringPrimitive.lodgingId as string,
    unavailable: parsedQueryStringPrimitive.unavailable === "true",
    source: parseEnum(
      DatelessSearchSource,
      parsedQueryStringPrimitive.source as string,
      DatelessSearchSource.Unknown
    ),
    vibe: parsedQueryStringPrimitive.vibe as string | undefined,
    fromDate: fromDateStr ? dayjs(fromDateStr).toDate() : undefined,
    untilDate: untilDateStr ? dayjs(untilDateStr).toDate() : undefined,
  };

  return parsedQueryString;
};
